import { Result } from "./common";

export interface BookingGuest {
  evtPmsCode: string;
  evtUId: number;
  shpid: number;
  shpShipName: string;
  rebcode: string;
  rebuid: number;
  refFolfolioId: number;
  folFullNameSal: string;
  folForeName: string;
  folSurName: string;
  folrepeaterno: string;
  loyaltylevel: string;
  benefitpoints: number;
}

export interface BookingGuestList {
  BookingGuestList: BookingGuest[];
  Result: Result;
}

export interface BookingGuestListResponse {
  GetBookingGuests: BookingGuestList;
}

export class BookingGuestListRequestBody {
  bookingID: number | undefined;

  constructor(bookingID: number | undefined) {
    this.bookingID = bookingID;
  }
}